module.exports = __webpack_public_path__ + "static/media/slide3.8e5b87b6.webp";